import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getProjectInput,
  getProjectsInput,
  ProjectLiteModel,
  ProjectModel,
} from './model';

export function useGetProjects(
  input?: getProjectsInput,
  options?: UseQueryOptions<ExtendedApiResult<ProjectLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<ProjectLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getProjects', input?.params],
      () =>
        QueryFetchFunction({
          url: 'projects',
          params: input?.params,
        }),
      options,
    ),
    ProjectLiteModel,
  );
}

export function useGetProject(
  input?: getProjectInput,
  options?: UseQueryOptions<ApiResult<ProjectModel>, ApiError>,
): UseQueryResult<ApiResult<ProjectModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getProject', input?.id],
      () => QueryFetchFunction({ url: `projects/${input?.id}` }),
      options,
    ),
    ProjectModel,
  );
}

export function getProjectsKey(input?: getProjectsInput) {
  return ['getProjects', input?.params];
}

export function getProjectKey(input?: getProjectInput) {
  return ['getProject', input?.id];
}
